// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".bulk_upload_modal-component .modal-body {\n  overflow-x: auto; }\n  .bulk_upload_modal-component .modal-body .bulk-upload-form .helper-file {\n    text-align: center;\n    font-size: .8rem;\n    margin-bottom: .7rem; }\n", ""]);
// Exports
module.exports = exports;
